export enum ColorTagPromotionEnum {
    ORANGE = 'ORANGE',
    SKY = 'SKY',
    BLUE = 'BLUE',
    RED = 'RED'
}

export const colorHexCodes = {
    [ColorTagPromotionEnum.ORANGE]: { top: '#F6B278', bottom: '#EB8229' },
    [ColorTagPromotionEnum.SKY]: { top: '#00B3F2', bottom: '#0080AE' },
    [ColorTagPromotionEnum.BLUE]: { top: '#1B5EE3', bottom: '#0F3470' },
    [ColorTagPromotionEnum.RED]: { top: '#EB455F', bottom: '#A91C32' }
};

export type ColorName = 'ORANGE' | 'SKY' | 'BLUE' | 'RED';